import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { ReactComponent as Comment } from '../svg/comment.svg';
import { ReactComponent as LinkIcon } from '../svg/linkIcon.svg';
import { getCircularAvatar } from '../utils/cloudinaryTransform';





// import EditDeleteMenu from '.EditDeleteMenu';

//  //

import { useSelector, useDispatch } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { UpvoteButton, DownvoteButton } from './VoteButtons';
import { notify } from '../reducers/notificationReducer';
import EditDeleteMenu from './EditDeleteMenu';
import getEditedThumbail from '../utils/cloudinaryTransform';
import { trimLink, prettifyLink, fixUrl } from '../utils/formatUrl';
import TimeAgo from 'timeago-react';
import getErrorMsg from '../utils/getErrorMsg';

import {
  Paper,
  useMediaQuery,
  Link,
  Button,
  SvgIcon,
} from '@material-ui/core';

import { useCardStyles } from '../styles/muiStyles';
import { useTheme } from '@material-ui/core/styles';
import MessageIcon from '@material-ui/icons/Message';
// import LinkIcon from '@material-ui/icons/Link';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import CommentIcon from '@material-ui/icons/Comment';
// import { useStyles } from '../styles/muiStyles';


const PostCard = ({ post, toggleUpvote, toggleDownvote }) => {
  
  const {
    id,
    title,
    postType,
    textSubmission,
    linkSubmission,
    imageSubmission,
    subreddit,
    author,
    authorAvatar,
    username: userName,
    upvotedBy,
    downvotedBy,
    pointsCount,
    commentCount,
    createdAt,
    updatedAt,
  } = post;


  const classes = useCardStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const dispatch = useDispatch();
  const { user, darkMode } = useSelector((state) => state);

  const isUpvoted = user && upvotedBy.includes(user.id);
  const isDownvoted = user && downvotedBy.includes(user.id);

  const handleUpvoteToggle = async () => {
    try {
      if (isUpvoted) {
        const updatedUpvotedBy = upvotedBy.filter((u) => u !== user.id);
        dispatch(toggleUpvote(id, updatedUpvotedBy, downvotedBy));
      } else {
        const updatedUpvotedBy = [...upvotedBy, user.id];
        const updatedDownvotedBy = downvotedBy.filter((d) => d !== user.id);
        dispatch(toggleUpvote(id, updatedUpvotedBy, updatedDownvotedBy));
      }
    } catch (err) {
      dispatch(notify(getErrorMsg(err), 'error'));
    }
  };

  const handleDownvoteToggle = async () => {
    try {
      if (isDownvoted) {
        const updatedDownvotedBy = downvotedBy.filter((d) => d !== user.id);
        dispatch(toggleDownvote(id, updatedDownvotedBy, upvotedBy));
      } else {
        const updatedDownvotedBy = [...downvotedBy, user.id];
        const updatedUpvotedBy = upvotedBy.filter((u) => u !== user.id);
        dispatch(toggleDownvote(id, updatedDownvotedBy, updatedUpvotedBy));
      }
    } catch (err) {
      dispatch(notify(getErrorMsg(err), 'error'));
    }
  };

  const linkToShow =
    postType === 'Link'
      ? linkSubmission
      : postType === 'Image'
      ? imageSubmission.imageLink
      : '';

  const formattedLink = trimLink(prettifyLink(linkToShow), 30);

  // alt={author.Avatar}
  // src={author.avatar.imageLink}

  return (
    <Card className={classes.card}>
      <div className={classes.authavatarWrapper}></div>
      <CardHeader
        avatar={
          authorAvatar?.avatar?.exists ? (
            <Avatar
              alt={author.username}
              src={getCircularAvatar(authorAvatar.avatar.imageLink)}
              className={classes.avatar}
            />
          ) : (
            <Avatar className={classes.avatar}>{author.username[0]}</Avatar>
          )
        }
        action={
          <IconButton aria-label="settings" style={{ marginBottom: -23 }}>
            {user && user.id === author.id && (
              <EditDeleteMenu
                id={id}
                isMobile={isMobile}
                title={title}
                postType={postType}
                subreddit={subreddit}
                textSubmission={textSubmission}
                linkSubmission={linkSubmission}
              />
            )}
          </IconButton>
        }
        title={
          <>
            <box-icon
              name="at"
              color="gray"
              animation="tada-hover"
              size="12px"
            ></box-icon>
            <Link component={RouterLink} to={`/u/${author.username}`}>
              {author.username}
            </Link>
          </>
        }
        subheader={
          <>
            <box-icon
              name="hive"
              color="gray"
              animation="tada-hover"
              size="12px"
            ></box-icon>
            <Link component={RouterLink} to={`/r/${subreddit.subredditName}`}>
              {subreddit.subredditName}
            </Link>
            &nbsp; • <TimeAgo datetime={new Date(createdAt)} />
            {createdAt !== updatedAt && "*"}
          </>
        }
      />

      <CardMedia className={classes.media}>
        <div className={classes.thumbnailWrapper}>
          {postType === "Text" ? (
            <RouterLink to={`/comments/${id}`}>
              <Paper className={classes.thumbnail}>
                <SvgIcon
                  style={{ marginRight: "0.2em" }}
                  className={classes.thumbnailIcon}
                  style={{ color: "#787878" }}
                >
                  <Comment style={{ color: "secondary" }} />
                </SvgIcon>

                {/* <MessageIcon
                className={classes.thumbnailIcon}
                style={{ color: '#787878' }}
              /> */}
              </Paper>
            </RouterLink>
          ) : postType === "Link" ? (
            <a href={fixUrl(linkSubmission)} target="_noblank">
              <Paper className={classes.thumbnail}>
                <SvgIcon
                  className={classes.thumbnailIcon}
                  style={{ marginRight: "0.2em" }}
                  fontSize="inherit"
                  style={{ color: "#787878" }}
                >
                  <LinkIcon />
                </SvgIcon>
              </Paper>
            </a>
          ) : (
            <CardMedia
              className={classes.thumbnail}
              image={getEditedThumbail(imageSubmission.imageLink)}
              title={title}
              component="a"
              href={imageSubmission.imageLink}
              target="_noblank"
            />
          )}
        </div>
      </CardMedia>

      <CardContent className={classes.CardContentStyle}>
        <div className={classes.postInfoWrapper}>
          <Typography
            variant="h6"
            style={{ fontSize: 15 }}
            className={classes.title}
          >
            {title}{" "}
            <Typography
              variant="caption"
              color="primary"
              className={classes.url}
            >
              <Link
                href={
                  postType === "Link"
                    ? fixUrl(linkSubmission)
                    : postType === "Image"
                    ? imageSubmission.imageLink
                    : ""
                }
              >
                {formattedLink}
                {postType === "Text" ? null : (
                  <OpenInNewIcon fontSize="inherit" />
                )}
              </Link>
            </Typography>
          </Typography>

          <div className={classes.bottomBtns}>
            <Button
              startIcon={
                <SvgIcon style={{ marginRight: "0.2em" }} fontSize="inherit">
                  <Comment style={{ color: "secondary" }} />
                </SvgIcon>
              }
              className={classes.commentsBtn}
              component={RouterLink}
              to={`/comments/${id}`}
              size={isMobile ? "small" : "medium"}
            >
              {commentCount} comments
            </Button>
          </div>

          <div className={classes.votesWrapper}>
            <UpvoteButton
              user={user}
              body={post}
              handleUpvote={handleUpvoteToggle}
              size={isMobile ? "small" : "medium"}
            />
            <Typography
              variant="body1"
              style={{
                color: isUpvoted
                  ? "#91c788"
                  : isDownvoted
                  ? "#91c788"
                  : darkMode
                  ? "#e4e4e4"
                  : "#757575",
                fontWeight: 600,
              }}
            >
              {pointsCount}
            </Typography>
            <DownvoteButton
              user={user}
              body={post}
              handleDownvote={handleDownvoteToggle}
              size={isMobile ? "small" : "medium"}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};  

export default PostCard;